// Data Models for Commission Tracker Application

// Raw data structures as received from sources
export const RawWellskyHeaders = {
  AGENCY_SUBDOMAIN: 'Agency Subdomain',
  ADDRESS: 'Address',
  POSTAL_CODE: 'Postal Code',
  DEACTIVATED: 'Deactivated',
  EMAIL: 'Email',
  FULL_NAME: 'Full Name',
  SPOUSE_NAME: 'Spouse Name',
  DATABASE_ID: 'Database ID',
  START_DATE: 'Start Date',
  DATE_DEACTIVATED: 'Date deactivated',
  CLIENT_REFERRER: 'Client Referrer',
  MARKETER: 'Marketer',
  REFERRAL_SOURCE_TYPE: 'Referral Source Type',
  MOBILE_PHONE: 'Mobile Phone',
  HOME_PHONE: 'Home Phone'
};

export const RawHubspotHeaders = {
  RECORD_ID: 'Record ID',
  DEAL_NAME: 'Deal Name',
  RESPONSIBLE_PARTY_FIRST_NAME: 'Responsible Party First Name',
  RESPONSIBLE_PARTY_LAST_NAME: 'Responsible Party Last Name',
  CLIENT_NAME: 'Client Name',
  PHONE_NUMBER_CLIENT: 'Phone Number (Client)',
  PHONE_NUMBER_RESPONSIBLE_PARTY: 'Phone Number (Responsible Party)',
  EMAIL_RESPONSIBLE_PARTY: 'Email (Responsible Party)',
  EMAIL_CLIENT: 'Email (Client)',
  DEAL_STAGE: 'Deal Stage',
  CLOSE_DATE: 'Close Date',
  PIPELINE: 'Pipeline',
  ASSESSMENT_STREET_ADDRESS: 'Assessment Street Address',
  ASSESSMENT_CITY: 'Assessment City',
  ASSESSMENT_POSTAL_CODE: 'Assessment Postal Code',
  ASSESSMENT_STATE: 'Assessment State',
  SERVICE_CITY: 'Service City',
  SERVICE_POSTAL_CODE: 'Service Postal Code',
  SERVICE_STATE: 'Service State',
  SERVICE_STREET_ADDRESS: 'Service Street Address',
  WELLSKY_DATABASE_ID: 'Wellsky Database ID',
  INSIDE_SALES_REP: 'Inside Sales Rep',
  COMMISSION_ELIGIBLE: 'Commission Eligible',
  CLIENT_TYPE: 'Client Type'
};

// Formatted data headers for display
export const FormattedWellskyHeaders = {
  DATABASE_ID: 'Database ID',
  FULL_NAME: 'Full Name',
  MOBILE_PHONE: 'Mobile Phone',
  HOME_PHONE: 'Home Phone',
  EMAIL: 'Email',
  STREET_NUMBER: 'Street Number',
  ADDRESS: 'Address',
  AGENCY_SUBDOMAIN: 'Agency Subdomain',
  START_DATE: 'Start Date',
  POSTAL_CODE: 'Postal Code',
  DEACTIVATED: 'Deactivated',
  SPOUSE_NAME: 'Spouse Name',
  DATE_DEACTIVATED: 'Date deactivated',
  CLIENT_REFERRER: 'Client Referrer',
  MARKETER: 'Marketer',
  REFERRAL_SOURCE_TYPE: 'Referral Source Type',
  FLAGGED_FOR_REVIEW: 'Flagged for Review'
};

export const FormattedHubspotHeaders = {
  WELLSKY_DATABASE_ID: 'Wellsky Database ID',
  FULL_NAME: 'Full Name',
  CLIENT_NAME: 'Client Name',
  PHONE_NUMBER_CLIENT: 'Phone Number (Client)',
  PHONE_NUMBER_RESPONSIBLE_PARTY: 'Phone Number (Responsible Party)',
  EMAIL_CLIENT: 'Email (Client)',
  EMAIL_RESPONSIBLE_PARTY: 'Email (Responsible Party)',
  CLOSE_DATE: 'Close Date',
  STREET_NUMBER_ASSESSMENT: 'Street Number (Assessment)',
  ASSESSMENT_STREET_ADDRESS: 'Assessment Street Address',
  ASSESSMENT_CITY: 'Assessment City',
  ASSESSMENT_POSTAL_CODE: 'Assessment Postal Code',
  ASSESSMENT_STATE: 'Assessment State',
  SERVICE_CITY: 'Service City',
  SERVICE_POSTAL_CODE: 'Service Postal Code',
  SERVICE_STATE: 'Service State',
  STREET_NUMBER_SERVICE: 'Street Number (Service)',
  SERVICE_STREET_ADDRESS: 'Service Street Address',
  RECORD_ID: 'Record ID',
  DEAL_NAME: 'Deal Name',
  DEAL_STAGE: 'Deal Stage',
  PIPELINE: 'Pipeline',
  INSIDE_SALES_REP: 'Inside Sales Rep',
  COMMISSION_ELIGIBLE: 'Commission Eligible',
  CLIENT_TYPE: 'Client Type'
};

export const DataMatchHeaders = {
  HUBSPOT_ROW: 'Hubspot Row',
  WELLSKY_ROW: 'Wellsky Row',
  ACTION_REQUIRED: 'Action Required',
  INVESTIGATION_REASON: 'Investigation Reason',
  COMMISSION_ELIGIBLE: 'Commission Eligible',
  HUBSPOT_DEAL_LINK: 'Hubspot Deal Link',
  DATABASE_ID: 'Database ID',
  WELLSKY_FULL_NAME: 'Wellsky Full Name',
  HUBSPOT_FULL_NAME: 'Hubspot Full Name',
  HUBSPOT_CLIENT_NAME: 'Hubspot Client Name',
  AGENCY_SUBDOMAIN: 'Agency Subdomain',
  START_DATE: 'Start Date',
  CLOSE_DATE: 'Close Date',
  INSIDE_SALES_REP: 'Inside Sales Rep',
  DATABASE_ID_MATCH: 'Database ID Match',
  FULL_NAME_MATCH: 'Full Name Match',
  PHONE_NUMBER_MATCH: 'Phone Number Match',
  EMAIL_MATCH: 'Email Match',
  STREET_NUMBER_POSTAL_CODE_MATCH: 'Street Number + Postal Code Match',
  MATCH_COUNT: 'Match Count'
};

export const CommissionTrackerHeaders = {
  HUBSPOT_DEAL_LINK: 'Hubspot Deal Link',
  DATABASE_ID: 'Database ID',
  WELLSKY_FULL_NAME: 'Wellsky Full Name',
  HUBSPOT_FULL_NAME: 'Hubspot Full Name',
  HUBSPOT_CLIENT_NAME: 'Hubspot Client Name',
  AGENCY_SUBDOMAIN: 'Agency Subdomain',
  START_DATE: 'Start Date',
  CLOSE_DATE: 'Close Date',
  INSIDE_SALES_REP: 'Inside Sales Rep',
  REP_COMMISSION: 'Rep Commission',
  MANAGER_COMMISSION: 'Manager Commission',
  MONTH_YEAR: 'Month/Year',
  TOTAL_DEALS_WON: 'Total Deals Won',
  TOTAL_COMMISSION: 'Total Commission',
  CHARITY_GRANDCHAMPT_MONTHLY_DEALS_WON: 'Charity Grandchampt Monthly Deals Won',
  CHARITY_GRANDCHAMPT_MONTHLY_COMMISSION: 'Charity Grandchampt Monthly Commission',
  IRVIN_TRAHAN_III_MONTHLY_DEALS_WON: 'Irvin Trahan III Monthly Deals Won',
  IRVIN_TRAHAN_III_MONTHLY_COMMISSION: 'Irvin Trahan III Monthly Commission',
  JOEL_THOMAS_MONTHLY_DEALS_WON: 'Joel Thomas Monthly Deals Won',
  JOEL_THOMAS_MONTHLY_COMMISSION: 'Joel Thomas Monthly Commission',
  TYSON_QUEEN_MONTHLY_DEALS_WON: 'Tyson Queen Monthly Deals Won',
  TYSON_QUEEN_MONTHLY_COMMISSION: 'Tyson Queen Monthly Commission',
  TOTAL_MANAGER_COMMISSION: 'Total Manager Commission'
};

// Action types for matching
export const MatchActions = {
  READY: 'Ready for Commission',
  INVESTIGATION: 'Investigation Needed', 
  NOT_ELIGIBLE: 'Not Commission Eligible'
};

// Utility function to create formatted record objects
export const createWellskyRecord = (data = {}) => ({
  databaseId: data.databaseId || '',
  fullName: data.fullName || '',
  mobilePhone: data.mobilePhone || '',
  homePhone: data.homePhone || '',
  email: data.email || '',
  streetNumber: data.streetNumber || '',
  address: data.address || '',
  agencySubdomain: data.agencySubdomain || '',
  startDate: data.startDate || '',
  postalCode: data.postalCode || '',
  deactivated: data.deactivated || false,
  spouseName: data.spouseName || '',
  dateDeactivated: data.dateDeactivated || '',
  clientReferrer: data.clientReferrer || '',
  marketer: data.marketer || '',
  referralSourceType: data.referralSourceType || '',
  flaggedForReview: data.flaggedForReview || false
});

export const createHubspotRecord = (data = {}) => ({
  recordId: data.recordId || '',
  dealName: data.dealName || '',
  fullName: data.fullName || '',
  clientName: data.clientName || '',
  phoneClient: data.phoneClient || '',
  phoneRep: data.phoneRep || '',
  emailClient: data.emailClient || '',
  emailRep: data.emailRep || '',
  closeDate: data.closeDate || '',
  assessment: {
    number: data.assessment?.number || '',
    street: data.assessment?.street || '',
    city: data.assessment?.city || '',
    postal: data.assessment?.postal || '',
    state: data.assessment?.state || ''
  },
  service: {
    number: data.service?.number || '',
    street: data.service?.street || '',
    city: data.service?.city || '',
    postal: data.service?.postal || '',
    state: data.service?.state || ''
  },
  wellskyDatabaseId: data.wellskyDatabaseId || '',
  salesRep: data.salesRep || '',
  commissionEligible: data.commissionEligible || false,
  clientType: data.clientType || '',
  dealStage: data.dealStage || '',
  pipeline: data.pipeline || ''
});

export const createMatchResult = (data = {}) => ({
  hubspotIndex: data.hubspotIndex || 0,
  wellskyIndex: data.wellskyIndex || null,
  criteria: {
    idMatch: data.criteria?.idMatch || false,
    nameMatch: data.criteria?.nameMatch || false,
    phoneMatch: data.criteria?.phoneMatch || false,
    emailMatch: data.criteria?.emailMatch || false,
    addressMatch: data.criteria?.addressMatch || false
  },
  score: data.score || 0,
  action: data.action || MatchActions.INVESTIGATION,
  investigationReason: data.investigationReason || '',
  hubspotRecord: data.hubspotRecord || null,
  wellskyRecord: data.wellskyRecord || null
});
